import { Component, Input, OnInit } from '@angular/core';

import { TimelineData } from "src/app/product-capture/model/interfaces/timeline-data.interface";

@Component({
  selector: 'app-dc-timeline',
  templateUrl: './dc-timeline.component.html',
  styleUrls: ['./dc-timeline.component.scss'],
})
export class DcTimelineComponent implements OnInit {
  @Input() timelineData: Array<TimelineData>;

  constructor() {}

  ngOnInit(): void {}
}
